import { toast } from "react-toastify";
import * as actionType from "../../../context/actions";

/**
 * Add or update a customer locally using dispatch and local state.
 * Also saves updated list to localStorage.
 */
const AddCustomerInLocal = async (state, dispatch, customerData) => {

    try {
        const existingCustomers = state?.CUSTOMERS || [];

        const matchedCustomer = existingCustomers.find(
            (cust) =>
                cust.customer?.toLowerCase() === customerData.customer?.toLowerCase()
        );

        // ✅ Declare at top
        let updatedCustomers = [];

        if (!matchedCustomer) {
            // ✅ Create new customer
            const newCustomer = {
                createdBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
                createdById: state?.USERID || null,
                updatedBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
                updatedById: state?.USERID || null,
                ...customerData,
                customerId: customerData.customerId || Date.now().toString(),
                createdAt: Date.now().toString(),
                updatedAt: Date.now().toString(),
                invoiceCount: "1",
                //invoices: [customerData.invoices?.[0] || ""],
                outstanding: customerData.totalAmount || "0",
                totalAmount: customerData.totalAmount || "0",
                totalPaid: "0",
                dialCode: customerData?.dialCode || customerData?.dial_code || "",

            };

            updatedCustomers = [...existingCustomers, newCustomer];
        } else {
            // ✏️ Update existing customer
            const updatedCustomer = {
                ...matchedCustomer,
                phone: customerData.phone,
                email: customerData.email,
                address: customerData.address,
                customerGSTNo: customerData.customerGSTNo,
                updatedAt: Date.now().toString(),
                dialCode: customerData?.dialCode || customerData?.dial_code || "",

            };

            updatedCustomers = existingCustomers.map((cust) =>
                cust.customerId === matchedCustomer.customerId ? updatedCustomer : cust
            );
        }

        // ✅ Use the common variable
        dispatch({
            type: actionType.CUSTOMERS,
            payload: updatedCustomers,
        });

        localStorage.setItem("LOCAL_CUSTOMER", JSON.stringify(updatedCustomers));

    } catch (error) {
        console.error("❌ Local AddCustomer error:", error);
    }
};

export default AddCustomerInLocal;
